import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
    AddCererePayload,
    EditCererePayload,
    EditRequestStatusPayload,
    EditRequestPriorityPayload,
    EditRequestAssigneePayload,
    extraActionCererePayload,
    DocumentData,
    UpdateMassAssignPayload,
    UpdateMassStatusPayload,
    IInchidereLucrare,
} from './cerere.interface';
import { Observable, Subject, catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: "root",
})
export class CereriService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private getRequestsURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.getCereriList;
    private getRequestsDTURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.getCereriListDT;
    private findCerere =
        this.basePath + environment.interop.autorizatiiComerciale.cerere.findCerere;
    private getInfoDocListURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.getInfoDocList;
    private storeRequestsURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.storeCereri;
    private updateRequestURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.updateCereri;
    private deleteRequestURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.deleteCereri;
    private updateStatusURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.updateStatus;
    private updatePriorityURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.updatePriority;
    private updateAssigneeURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.updateAssignee;

    private postMessageURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.postMessage;
    private rePostMessageURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.rePostMessage;

    // new routes
    private preluarePersonalaUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.preluarePersonala;
    private preluareNumarRegistraturaUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.preluareNumarRegistratura;
    private validateCerereUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.validateCerere;
    private invalidateCerereUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.invalidateCerere;
    private anulareCerereUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.anulareCerere;
    private finalizareCerereUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.finalizareCerere;
    private getCerereTypesUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.cerereType
            .getCerereTypes;
    private getCerereTypesByCompUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.cerereType
            .listByCompartment;

    private getOperatoriByCompartimentUrl =
        this.basePath + environment.interop.autorizatiiComerciale.nomenclatoare.user.getUsersByComp;

    // operations
    public downloadDocumentUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.downloadDocument;

    private fileUploadUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.file.fileUpload;
    private fileUploadBase64Url =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.file.fileUploadBase64;

    private generateDocumentUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.generateDocument;

    private generateDocumentWithFileUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.uploadOnlineDocument;

    private validateDocumentUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.validateDocument;

    private resetDocumentValidatedUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.resetDocumentValidated;

    private resetDocumentIntocmitorValidatedUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere
            .resetDocumentIntocmitorValidated;

    private uploadFinalDocumentUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.uploadedFinalDocument;

    private addToRegistruUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.addToRegistru;

    public downloadDocumentOfficialUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.downloadDocumentOfficial;

    private istoricDocumentUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.istoricDocument;

    private destroyDocumentUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.destroyDocument;

    private updateDocumentUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.updateDocument;

    private updateValabilityDocGenerabilUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere
            .editValabilitateDocGenerabil;

    private validateDocumentSuperiorUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.validateDocumentSuperior;

    public downloadDocumentSignedUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.downloadDocumentSigned;

    public downloadDocumentGeneratUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.downloadDocumentGenerat;

    public downloadDocumentSignatureSignedUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere
            .downloadDocumentSignatureSigned;

    public downloadDocumentAnexaUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.downloadDocumentAnexa;

    private anulareSuperiorDocumentUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.cancelDocumentSuperior;

    private generareDraftURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.generareDraft;

    // Directii

    private getDirectiiActiveUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.directie
            .getDirectiiActive;

    // Compartimente

    private getCompartimenteActiveUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.compartiment
            .getCompartimenteActive;

    private getCompartimenteByDirectieUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.compartiment
            .getCompartimenteByDirectie;

    private getCompartimenteByAutcomUrl =
        this.basePath + environment.interop.autorizatiiComerciale.nomenclatoare.compartiment.getCompartimenteByAutcom;

    // Mass update & assign

    private massUpdateStatusURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.massUpdateStatus;

    private massAssignURL =
        this.basePath + environment.interop.autorizatiiComerciale.cerere.massAssign;

    public downloadTableSignaturesURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.downloadTableSignatures;

    private sablonContent = new Subject<string>();
    sablonContent$ = this.sablonContent.asObservable();

    private sendDocumentToIntocmitorUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.sendDocumentToIntocmitor;
    private sendDocumentForwardIntocmitorUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere
            .sendDocumentForwardIntocmitor;
    private sendDocumentForwardToSignerUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere
            .sendDocumentForwardToSigner;

    private rsyncSignaturesDocumentGeneratUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere
            .rsyncSignaturesDocumentGenerat;

    private exportHistoryUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.exportHistory;

    private resetValidareCerereUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.resetValidareCerere;

    private resetinValidareCerereUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.resetinValidareCerere;

    private resetClasareCerereUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.resetClasareCerere;

    private resetInchidereCerereUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.resetInchidereCerere;

    private sendNotificationCetateanDocumentOficialUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere
            .sendNotificationCetateanDocumentOficial;

    private resetDocumentOficialNotificareCetateanUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere
            .resetDocumentOficialNotificareCetatean;

    private resetUploadDocumentOfficialUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere
            .resetUploadDocumentOfficial;

    public downloadManualUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.cerere.downloadManual;

    private storeNewCerereURL =
        this.basePath + environment.interop.autorizatiiComerciale.cerere.store;

    private fileUploadBorderouUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderou.uploadFile;
    private cerereUpdateMetadateUrl =
        this.basePath + environment.interop.autorizatiiComerciale.cerere.cerereUpdateMetadate;

    private setDocTypeForDocumentUrl =
        this.basePath + environment.interop.autorizatiiComerciale.cerere.setDocTypeForDocument;

    private updateCurrentSignatureDocumentUrl =
        this.basePath + environment.interop.autorizatiiComerciale.cerere.updateCurrentSignatureDocument;

    private updateSlaUrl =
        this.basePath + environment.interop.autorizatiiComerciale.cerere.updateSla;

    private getJudeteUrl =
        environment.interop.authCore.basePath + environment.interop.authCore.nomenclatoare.judet.list;

    constructor(private http: HttpClient) { }

    store(data: {}) {
        return this.http.post(this.storeNewCerereURL, data, this.httpOptions);
    }

    getRequestTypes(id: number) {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCerereTypesByCompUrl + id
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request types:', error);
                    return throwError(error);
                })
            );
    }

    getOperatoriByCompartiment(id: number) {
        return this.http
            .post<{ errors: boolean; data: any[]; status_code: number }>(
                this.getOperatoriByCompartimentUrl, { compartiment_id: id }
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get operatori by compartiment:', error);
                    return throwError(error);
                })
            );
    }

    getRequests() {
        return this.http.get(this.getRequestsURL, this.httpOptions);
    }

    generareDraft(id_cerere: number) {
        return this.http.get(this.generareDraftURL + id_cerere, {
            responseType: "blob",
        });
    }

    getRequestsDT() {
        return this.http.get(this.getRequestsDTURL, this.httpOptions);
    }

    getRequestById(id: number) {
        return this.http.get(this.findCerere + id);
    }

    addRequest(request: AddCererePayload) {
        return this.http.post(this.storeRequestsURL, request, this.httpOptions);
    }

    updateRequest(request: EditCererePayload) {
        return this.http.put(this.updateRequestURL, request, this.httpOptions);
    }

    deleteRequest(id: number) {
        return this.http.delete(this.deleteRequestURL + id);
    }

    getInfoDocList(id: number) {
        return this.http.get(this.getInfoDocListURL + id);
    }

    updateRequestStatus(requestId: number, status: EditRequestStatusPayload) {
        return this.http.put(
            this.updateStatusURL + requestId,
            status,
            this.httpOptions
        );
    }

    updateRequestPriority(
        requestId: number,
        priority: EditRequestPriorityPayload
    ) {
        return this.http.put(
            this.updatePriorityURL + requestId,
            priority,
            this.httpOptions
        );
    }

    updateRequestAssignee(requestId: number, data: EditRequestAssigneePayload) {
        return this.http.put(
            this.updateAssigneeURL + requestId,
            data,
            this.httpOptions
        );
    }

    postMessage(id: number, message: any) {
        return this.http.post(this.postMessageURL + id, message, this.httpOptions);
    }

    rePostMessage(id: number) {
        return this.http.post(this.rePostMessageURL + id, this.httpOptions);
    }

    preluarePersonala(cerereId: number) {
        return this.http.get(
            this.preluarePersonalaUrl + cerereId,
            this.httpOptions
        );
    }

    validateCerere(cerereId: number) {
        console.log(cerereId);
        return this.http.post(this.validateCerereUrl + cerereId, this.httpOptions);
    }

    invalidateCerere(cerereId: number, data: extraActionCererePayload) {
        return this.http.post(
            this.invalidateCerereUrl + cerereId,
            data,
            this.httpOptions
        );
    }

    anulareCerere(cerereId: number, data: extraActionCererePayload) {
        return this.http.post(
            this.anulareCerereUrl + cerereId,
            data,
            this.httpOptions
        );
    }

    finalizareCerere(cerereId: number, data: IInchidereLucrare) {
        return this.http.post(
            this.finalizareCerereUrl + cerereId,
            data,
            this.httpOptions
        );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }

    fileUpload(formData: FormData) {
        return this.http.post<{ data: any }>(this.fileUploadUrl, formData);
    }

    fileUploadBorderou(data: any) {
        return this.http.post<{ data: any }>(this.fileUploadBorderouUrl, data);
    }

    generateDocument(cerereId: number, templateId: number, data: any) {
        return this.http.post<{ data: any }>(
            this.generateDocumentUrl + cerereId,
            // this.generateDocumentUrl + cerereId + "/" + templateId,
            data
        );
    }

    generateDocumentWithFile(cerereId: number, data: any) {
        return this.http.post<{ data: any }>(
            this.generateDocumentWithFileUrl + cerereId,
            data
        );
    }
    validateDocument(id: number, data: any) {
        // small switch here
        // let path =
        //    type == 1 ? this.validateDocumentUrl : this.validateDocumentSuperiorUrl;
        return this.http.post(this.validateDocumentUrl + id, data);
    }

    resetDocumentValidated(id: number, data: any) {
        return this.http.post(this.resetDocumentValidatedUrl + id, data);
    }

    resetDocumentIntocmitorValidated(id: number, data: any) {
        return this.http.post(this.resetDocumentIntocmitorValidatedUrl + id, data);
    }

    uploadFinalDocument(id: number, data: DocumentData) {
        return this.http.post(this.uploadFinalDocumentUrl + id, data);
    }

    addToRegistru(
        cerere_id: number,
        document_id: number,
        data: { valability: Date }
    ) {
        return this.http.post(
            this.addToRegistruUrl + cerere_id + "/" + document_id,
            data
        );
    }

    editDocGenerabilValabilty(document_id: number, data: { valability: Date }) {
        return this.http.post(
            this.updateValabilityDocGenerabilUrl + document_id,
            data
        );
    }
    cerereUpdateMetadate(id: number, data: any) {
        return this.http.put(this.cerereUpdateMetadateUrl + id, data);
    }
    downloadDocumentOfficial(id: number) {
        return this.http.get(this.downloadDocumentOfficialUrl + id);
    }

    downloadTableSignatures(id: number) {
        return this.http.get(this.downloadTableSignaturesURL + id);
    }

    downloadDocumentSigned(id: number) {
        return this.http.get(this.downloadDocumentSignedUrl + id);
    }

    downloadDocumentGenerat(id: number) {
        return this.http.get(this.downloadDocumentGeneratUrl + id);
    }

    downloadDocumentSignatureSigned(id: number) {
        return this.http.get(this.downloadDocumentSignatureSignedUrl + id);
    }

    downloadDocumentAnexa(id: number) {
        return this.http.get(this.downloadDocumentAnexaUrl + id);
    }

    istoricDocument(id: number) {
        return this.http.get(this.istoricDocumentUrl + id);
    }

    destroyDocument(id: number, data: any) {
        return this.http.post(this.destroyDocumentUrl + id, data);
    }

    updateDocument(id: number, data: DocumentData) {
        return this.http.post(this.updateDocumentUrl + id, data);
    }

    anulareSuperiorDocument(signatureId: number, data: any) {
        return this.http.post(this.anulareSuperiorDocumentUrl + signatureId, data);
    }

    getDirectii() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getDirectiiActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_directie,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error("Error in get directii active:", error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error("Error in get compartimente active:", error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteByDirectieId(id: number) {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteByDirectieUrl + id
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error("Error in getCompartimenteByDirectieId:", error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteByAutcom() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteByAutcomUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in getCompartimenteByAutcom:', error);
                    return throwError(error);
                })
            );
    }

    getRequestsIDs() {
        return this.http.get<any>(this.getRequestsDTURL).pipe(
            map((response) =>
                response.data.data.map((item: any) => ({
                    id: item.id_cerere,
                    name: item.subject,
                }))
            ),
            catchError((error) => {
                console.error("Error in get requests select:", error);
                return throwError(error);
            })
        );
    }

    updateMassAssign(data: UpdateMassAssignPayload) {
        return this.http.post(this.massAssignURL, data, this.httpOptions);
    }

    updateMassStatus(data: UpdateMassStatusPayload) {
        return this.http.post(this.massUpdateStatusURL, data, this.httpOptions);
    }

    preluareNumarRegistratura(cerereId: number) {
        return this.http.put(
            this.preluareNumarRegistraturaUrl + cerereId,
            this.httpOptions
        );
    }

    sendContent(content: string) {
        this.sablonContent.next(content);
    }

    sendDocumentToIntocmitor(signatureId: number, data: any) {
        return this.http.put(this.sendDocumentToIntocmitorUrl + signatureId, data);
    }

    sendDocumentForwardIntocmitor(documentId: number, data: any) {
        return this.http.put(
            this.sendDocumentForwardIntocmitorUrl + documentId,
            data
        );
    }

    sendDocumentForwardToSigner(signatureId: number, data: any) {
        return this.http.put(
            this.sendDocumentForwardToSignerUrl + signatureId,
            data
        );
    }

    rsyncSignaturesDocumentGenerat(documentId: number, doc_type: number, data: any = {}) {
        return this.http.post(
            this.rsyncSignaturesDocumentGeneratUrl + documentId + '/' + doc_type,
            data
        );
    }

    exportHistory(cerere_id: number, user_type: number): Observable<Blob> {
        return this.http.get(this.exportHistoryUrl + cerere_id + "/" + user_type, {
            responseType: "blob",
        });
    }

    resetValidareCerere(cerereId: number, data: any) {
        return this.http.put(this.resetValidareCerereUrl + cerereId, data);
    }

    resetinValidareCerere(cerereId: number, data: any) {
        return this.http.put(this.resetinValidareCerereUrl + cerereId, data);
    }

    resetClasareCerere(cerereId: number, data: any) {
        return this.http.put(this.resetClasareCerereUrl + cerereId, data);
    }

    resetInchidereCerere(cerereId: number, data: any) {
        return this.http.post(this.resetInchidereCerereUrl + cerereId, data);
    }

    sendNotificationCetateanDocumentOficial(documentGeneratId: number) {
        return this.http.get(
            this.sendNotificationCetateanDocumentOficialUrl + documentGeneratId,
            this.httpOptions
        );
    }

    resetDocumentOficialNotificareCetatean(id: number) {
        return this.http.post(
            this.resetDocumentOficialNotificareCetateanUrl + id,
            this.httpOptions
        );
    }

    resetUploadDocumentOfficial(id_document: number) {
        return this.http.post(
            this.resetUploadDocumentOfficialUrl + id_document,
            this.httpOptions
        );
    }

    downloadManual() {
        return this.http.get(this.downloadManualUrl);
    }

    setDocTypeForDocument(id: number) { // id => id_document - generat
        return this.http.get(this.setDocTypeForDocumentUrl + id, this.httpOptions);
    }

    updateCurrentSignatureDocument(documentId: number, data: any) {
        return this.http.put(
            this.updateCurrentSignatureDocumentUrl + documentId,
            data,
            this.httpOptions
        );
    }

    updateSla(cerereId: number, data?: any) {
        return this.http.put(this.updateSlaUrl + cerereId, data, this.httpOptions);
    }

    getJudete() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getJudeteUrl
            )
            .pipe(
                map((response) =>
                    response.data
                        .filter(item => item.name !== 'Altele')
                        .map((item) => ({
                            id: item.id,
                            name: item.name,
                        }))
                ),
                catchError((error) => {
                    console.error('Error in get judete:', error);
                    return throwError(error);
                })
            );
    }
}


// reset pentru incarca Docu Oficial ( verde) resetUploadDocumentOfficial
// reset dupa ce se da trimite documet oficial cetatean  resetDocumentOficialNotificareCetatean()